const getItemInfo = async (url: string) => {
  try {
    const fetchInfo = await fetch(url);

    const toJson = await fetchInfo.json();
    // when data is not available, the response will have an error property
    if (toJson?.error) {
      return { success: false, error: toJson.error };
    }
    return { success: true, data: toJson };
  } catch (error) {
    console.error("Error", error);
    return { success: false, error };
  }
};

/*
 * @description: When creating feature services, sometimes the data is not immediately available.
 * before trying to use the data, we need to check if the data is available.
 * */
export const retryRequest = async (url: string) => {
  let retries = 0;
  const maxRetries = 70;
  const twoSeconds = 3000;

  const innerMethod = async (): Promise<any> => {
    if (retries >= maxRetries) {
      return {
        success: false,
        data: null,
      };
    }
    const response = await getItemInfo(url);
    if (response?.error) {
      retries++;
      await new Promise((resolve) => setTimeout(resolve, twoSeconds));
      return await innerMethod(); // Recursively call until status is not 'processing' or retries are exhausted
    } else {
      return {
        success: true,
        data: response,
      }; // Return true immediately if status is not 'processing'
    }
  };

  return innerMethod();
};
